import { useContext } from "react";
import Context from "./context";

const useTenant = () => {
	const tenant = useContext(Context);
	return tenant;
};

export default useTenant;
